import { Vector2 } from "@babylonjs/core/Maths/math";
import { Tools } from "@babylonjs/core/Misc/tools";
import { ProceduralTexture } from "@babylonjs/core/Materials/Textures/Procedurals/proceduralTexture";
import { _Exporter } from "../glTFExporter";
var NAME = "KHR_texture_transform";
import "../shaders/textureTransform.fragment";
/**
 * @hidden
 */

var KHR_texture_transform =
/** @class */
function () {
  function KHR_texture_transform(exporter) {
    /** Name of this extension */
    this.name = NAME;
    /** Defines whether this extension is enabled */

    this.enabled = true;
    /** Defines whether this extension is required */

    this.required = false;
    this._exporter = exporter;
  }

  KHR_texture_transform.prototype.dispose = function () {
    delete this._exporter;
  };

  KHR_texture_transform.prototype.preExportTextureAsync = function (context, babylonTexture, mimeType) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var texture_transform_extension = {};

      if (babylonTexture.uOffset !== 0 || babylonTexture.vOffset !== 0) {
        texture_transform_extension.offset = [babylonTexture.uOffset, babylonTexture.vOffset];
      }

      if (babylonTexture.uScale !== 1 || babylonTexture.vScale !== 1) {
        texture_transform_extension.scale = [babylonTexture.uScale, babylonTexture.vScale];
      }

      if (babylonTexture.wAng !== 0) {
        texture_transform_extension.rotation = babylonTexture.wAng;
      }

      if (!Object.keys(texture_transform_extension).length) {
        resolve(babylonTexture);
      }

      var scale = texture_transform_extension.scale ? new Vector2(texture_transform_extension.scale[0], texture_transform_extension.scale[1]) : Vector2.One();
      var rotation = texture_transform_extension.rotation != null ? texture_transform_extension.rotation : 0;
      var offset = texture_transform_extension.offset ? new Vector2(texture_transform_extension.offset[0], texture_transform_extension.offset[1]) : Vector2.Zero();
      var scene = babylonTexture.getScene();

      if (!scene) {
        reject(context + ": \"scene\" is not defined for Babylon texture " + babylonTexture.name + "!");
      } else {
        _this.textureTransformTextureAsync(babylonTexture, offset, rotation, scale, scene).then(function (texture) {
          resolve(texture);
        });
      }
    });
  };
  /**
   * Transform the babylon texture by the offset, rotation and scale parameters using a procedural texture
   * @param babylonTexture
   * @param offset
   * @param rotation
   * @param scale
   * @param scene
   */


  KHR_texture_transform.prototype.textureTransformTextureAsync = function (babylonTexture, offset, rotation, scale, scene) {
    return new Promise(function (resolve, reject) {
      var proceduralTexture = new ProceduralTexture("" + babylonTexture.name, babylonTexture.getSize(), "textureTransform", scene);

      if (!proceduralTexture) {
        Tools.Log("Cannot create procedural texture for " + babylonTexture.name + "!");
        resolve(babylonTexture);
      }

      proceduralTexture.setTexture("textureSampler", babylonTexture);
      proceduralTexture.setMatrix("textureTransformMat", babylonTexture.getTextureMatrix()); // isReady trigger creation of effect if it doesnt exist yet

      if (proceduralTexture.isReady()) {
        proceduralTexture.render();
        resolve(proceduralTexture);
      } else {
        proceduralTexture.getEffect().executeWhenCompiled(function () {
          proceduralTexture.render();
          resolve(proceduralTexture);
        });
      }
    });
  };

  return KHR_texture_transform;
}();

export { KHR_texture_transform };

_Exporter.RegisterExtension(NAME, function (exporter) {
  return new KHR_texture_transform(exporter);
});